import { helpers } from '../../common/lib';
import getInitialState from '../get-initial-state';
import { actionTypes } from './actions';

export default function (state = getInitialState.auditFilters(), action) {
  switch (action.type) {
    case actionTypes.AUDIT_FILTERS_SET: {
      const { auditFilters } = action.payload;
      return auditFilters;
    }
    case actionTypes.AUDIT_FILTERS_UPDATE: {
      const { auditFilters } = action.payload;
      return { ...state, ...auditFilters };
    }
    default: {
      return state;
    }
  }
}
